import React from 'react';

// Hover-revealed row actions — the sidebar's ⋯ and the assistant's copy /
// regenerate / 👍 👎 (core.md §9.1, §9.3).
//
// Done in CSS, not JS: `:hover` and `:focus-within` on a host class, so the
// controls are also revealed for a keyboard user tabbing INTO the row, and no
// component tracks a `hovered` state that a fast pointer can leave stale.
//
// Only where hovering exists. `@media (hover: hover) and (pointer: fine)`
// leaves a touch screen with the controls ALWAYS visible — a control a finger
// cannot hover into being is a control that does not exist on a phone.
//
// The controls are faded, never removed: `opacity` keeps them in the tab order
// and in the accessibility tree, and `pointer-events` is untouched so a test or
// a screen reader finds the same buttons a pointer does.

export const HOVER_HOST = 'chat-hover-host';
export const HOVER_ACTIONS = 'chat-hover-actions';

const CSS = `
@media (hover: hover) and (pointer: fine) {
  .${HOVER_HOST} .${HOVER_ACTIONS} { opacity: 0; transition: opacity 120ms ease; }
  .${HOVER_HOST}:hover .${HOVER_ACTIONS},
  .${HOVER_HOST}:focus-within .${HOVER_ACTIONS} { opacity: 1; }
}
`;

/** The one rule sheet, rendered by whichever host mounts first (duplicates are harmless). */
export function HoverRevealStyle() {
  return <style data-chat-hover-reveal="">{CSS}</style>;
}
